import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/index.css";
import reportWebVitals from "./reportWebVitals";
import Loading from "./components/Animation/Loading";
const App = React.lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense
    fallback={
      <center style={{ marginTop: "10%" }}>
        <h1 style={{ color: "var(--text-color)" }}>Loading...</h1>
        <Loading />
      </center>
    }
  >
    <App />
  </Suspense>,
  document.getElementById("root")
);

reportWebVitals();
